module.exports = __webpack_public_path__ + "781b5cb0299c97e1991653acb8b8cb8a.pdf";